import PropTypes from 'prop-types';

export const bucketPropType = {
    name: PropTypes.string.isRequired,
    numSelected: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
};
